import { getTermsValue, resetTerms, setTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { ROOMS_TOTAL_MAP_VALUE_TO_LABEL } from './constants';
import { ERoomsTotal } from '../../../../api-models/common/json_query';
import { createTagValue } from '../../utils/createTagValue';

const ID = 'roomsTotal' as const;

export const roomsTotalTagsManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const roomsTotal = getTermsValue('rooms_count')(jsonQuery);

    if (roomsTotal === null || roomsTotal.includes(ERoomsTotal.Any)) {
      return null;
    }

    return roomsTotal.map(total => ({
      label: `Комнат в квартире: ${ROOMS_TOTAL_MAP_VALUE_TO_LABEL[total]}`,
      value: createTagValue(ID, total.toString()),
    }));
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery, removingTagValue }) => {
    const roomsTotal = getTermsValue('rooms_count')(jsonQuery);

    if (roomsTotal === null) {
      return jsonQuery;
    }

    const newRoomsTotal = roomsTotal.filter(total => String(total) !== removingTagValue);

    return newRoomsTotal.length
      ? setTerms('rooms_count')(jsonQuery)(newRoomsTotal)
      : resetTerms(['rooms_count'])(jsonQuery);
  },
};
